<template>
  <v-main id="calendar">
    <div class="fill-height">
      <v-sheet height="75">
        <v-row>
          <v-col class="col-md-4 py-0">
            <v-toolbar flat color="white">
              <v-btn outlined small height="30px" color="primary" to="/faturamento/agendacronogramas/gerenciarferiados" :disabled="!permissoes.portal.includes('addferiado')">Gerenciar Feriados</v-btn>
            </v-toolbar>
          </v-col>
          <v-col class="col-md-4 py-0">
            <v-toolbar flat color="white" class="select-month" style="padding-left: 70px;">
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon color="primary" style="font-size: 40px;" small>mdi-chevron-left</v-icon>
              </v-btn>

              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>

              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon color="primary" style="font-size: 40px;" small>mdi-chevron-right</v-icon>
              </v-btn>
            </v-toolbar>
          </v-col>

          <v-col class="col-md-4 py-0 btn-today">
            <v-toolbar flat  color="white">
              <v-spacer></v-spacer>
              <v-btn depressed small height="30px" color="primary" @click="setToday">Hoje</v-btn>
            </v-toolbar>
          </v-col>
        </v-row>
      </v-sheet>

      <v-sheet class="calendar-body">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="filteredEvents"
          :event-color="getEventColor"
          @click:event="eventclick"
          @click:more="viewDay"
          locale="pt"
          :short-weekdays="false"
          :show-month-on-first="false"
          @change="updateRange"
          v-if="showCalendar"
        >
         <!-- :day-class="(date)=> 'date'+date" -->
         <template v-slot:day="{ date }" >
           <v-layout class="fill-height" style="position:absolute; top:0; left:0; width: 100%">
           <button v-if="isDateButton(date)" style="position:absolute;outline:none;color:transparent" @click="buttonDay(date)">day</button>
           <v-sheet
                  v-if="isHoliday(date)"
                  color="rgba(0,0,0,0)"
                  width="100%"
                  tile
                  class="d-flex align-center feriado"
                ><p class="text-center align-content-center text--secondary" style="width:100%">{{getHolidayDesc(date)}}</p>
                </v-sheet>
           </v-layout>
          </template>
          <template v-slot:event="{ event }">
              <v-row wrap class="ma-1 pa-1" >
                <v-col cols="12" class="pa-0 ma-0 mb-1">
                  <p class="items-card pa-0 ma-0 negrito text-right">{{ event.oper_nome }}</p>
                </v-col>
                <v-col cols="12" class="pa-0 ma-0 mb-1" style="white-space: wrap !important;">
                  <p class="items-card pa-0 ma-0 ">{{ event.prest_nome }}</p>
                </v-col>
                <v-col cols="4" class="pa-0 ma-0">
                  <p class="items-card pa-0 ma-0 " v-if='event.num_cronos'>{{ event.num_cronos }} cron.</p>
                </v-col>
                <v-col cols="8" class="pa-0 ma-0">
                  <p class="items-card pa-0 ma-0 text-right">{{ event.vl_prev_faturamento | formatPrice }}</p>
                </v-col>
              </v-row>
          </template>
        </v-calendar>
        <v-dialog v-model="dialog" max-width="400" style="max-height: 90%; width: 90%; margin-left: 100px;">
          <v-card>
            <v-container class="agenda-calendar">
              <v-row class="px-1">
                <v-col cols="6" class="py-0 mt-2 mb-0">
                  <p class="legend-day">{{day}}/{{month}}/{{year}}</p>
                  <p v-if="isHoliday(`${year}-${month}-${day}`)">Feriado: {{ getHolidayDesc(`${year}-${month}-${day}`)}}</p>
                </v-col>
                <v-col cols="6" class="py-0 mt-2 text-right">
                  <p class="close-x" @click="dialog = false">X</p>
                </v-col>
              </v-row>
              <v-sheet height="100%">
                <!-- <v-list-item  > -->
               <v-row wrap :class="[getClass(ind), 'ma-1', 'py-2', 'px-4']"  v-for="(item, ind) in listEvent"  v-on:click="eventclick({day:{date:`${year}-${month}-${day}`}, event: item})" :key="ind">
                <v-col cols="6" class="pa-0 ma-0 mb-1" >
                  <p class="items-card pa-0 ma-0 " style="white-space: nowrap !important; overflow: hidden; text-overflow: ellipsis">{{ item.prest_nome }}</p>
                </v-col>
                <v-col cols="6" class="pa-0 ma-0 mb-1">
                  <p class="items-card pa-0 ma-0 text-right"><b>{{ item.oper_nome }}</b></p>
                </v-col>
                <v-col cols="4" class="pa-0 ma-0">
                  <p class="items-card pa-0 ma-0 " v-if='item.num_cronos'>{{ item.num_cronos }} cron.</p>
                </v-col>
                <v-col cols="8" class="pa-0 ma-0">
                  <p class="items-card pa-0 ma-0 text-right">{{ item.vl_prev_faturamento | formatPrice }}</p>
                </v-col>
              </v-row>
                <!-- </v-list-item> -->
              </v-sheet>
              <!-- <v-sheet v-for="item in listEvent" :key="item.id" height="100%">
                <v-toolbar class="mb-2" style="border-radius: 2px;" :color="item.color" flat>
                  <v-col class="py-0">
                    <p class="items-menu">{{item.prest_nome}}</p>
                    <v-spacer></v-spacer>
                    <p class="items-menu">{{item.owner_username}}</p>
                  </v-col>
                  <v-col class="py-0">
                    <p class="items-menu text-right">
                      {{item.oper_nome}} 
                    </p>
                    <v-spacer></v-spacer>
                    <p class="items-menu negrito text-right">{{ item.vl_prev_faturamento | formatPrice }}</p>
                  </v-col>
                </v-toolbar>
              </v-sheet> -->
            </v-container>
          </v-card>
        </v-dialog>
      </v-sheet>
    </div>
  </v-main>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      showCalendar: false,
      focus: "",
      day: "",
      month: "",
      year: "",
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      filteredEvents: [],
      dialog: false,
      listEvent: []
    };
  },
  props: {
    eventclick: Function,
    events: Array,
    feriadosList: Array,
    openShow: Function,
    referenceYear: Number,
    newFeriadosList: Function,
    permissoes: Object
  },
  filters: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  watch: {
    events:{
      deep: true,
      handler() {
        this.showCalendar = false
        setTimeout(()=>this.showCalendar = true, 5) 
      }
    }
  },
  mounted() {
    setTimeout(()=>this.showCalendar = true, 5) 
  },
  methods: {
    isDateButton(date) {
      return  this.filteredEvents.find(filteredEvents => filteredEvents.start.split('T')[0] == date)
    },
    isHoliday(date) {
      return  this.feriadosList.find(holiday => holiday.dt_feriado.split('T')[0] == date)
    },
    getHolidayDesc(date){
      return  this.feriadosList.find(holiday => holiday.dt_feriado.split('T')[0] == date).descricao
    },
    viewDay({ date }) {
      this.focus = date;
      this.day = this.focus.substring(8, 11);
      this.month = this.focus.substring(5, 7);
      this.year = this.focus.substring(0, 4);
      this.filterDate(date);
    },
    buttonDay(date) {
      this.focus = date
      this.day = this.focus.substring(8, 11)
      this.month = this.focus.substring(5, 7)
      this.year = this.focus.substring(0, 4)
      this.filterDate(date)
    },
    validateDay() {},
    filterDate(item) {
      let aux =  this.events.filter(event => moment(event.start).format('YYYY-MM-DD') == item);
      this.listEvent = aux;
      if (aux.length) {
        this.dialog = true;
      }
    },
    getClass(){ //ind
      // let estilo = ind%2 == 0 ? 'card-even' : 'card-odd'
      // return estilo
      return 'card-even'
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    updateRange({ start, end }) {
      if(start.year < this.referenceYear || end.year > this.referenceYear +1  ){
        this.newFeriadosList(start.year)
      }
      let events = [];
      events = Array.from(this.events)
      function compare(a, b) {
        return (a.start > b.start)? 1 : -1
      }
      events.sort(compare)

      this.start = start;
      this.end = end;
      this.filteredEvents = events;
    },
  },
};
</script>

<style lang="scss">
#calendar {
  .calendar-body {
    width: 100%;
    height: 750px;
  }

  .theme--light.v-calendar-weekly {
    background-color: #ffffff;
    border-top: none;
    border-left: none;
  }

  .v-toolbar__content,
  .v-toolbar__extension {
    padding: 4px 0px;
  }

  .v-calendar-monthly.v-calendar-weekly.v-calendar.theme--light.v-calendar-events {
    border-top: none;
    border-left: none;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
    background-color: #ffffff;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {
    border-right: none;
    color: #000000;
    margin-bottom: 15px;
  }

  .v-calendar-weekly__head-weekday {
    flex: 1 0 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0 1px;
    font-size: 11px;
    overflow: hidden;
    text-align: initial;
    text-overflow: ellipsis;
    text-transform: uppercase;
    white-space: nowrap;
  }

  .v-calendar-weekly__day-label {
    text-align: initial;
    margin: 0;
  }

  .v-calendar-weekly__week {
    border-left: #e0e0e0 1px solid;
  }

  button.v-btn.v-btn--depressed.v-btn--fab.v-btn--round.theme--light.v-size--small.primary {
    width: 19px;
    height: 19px;
    margin: 5px 2px 1px;
  }

  .v-calendar-weekly__day-label .v-btn {
    font-size: 12px;
    text-transform: none;
    margin: 5px 2px 1px;
    width: 18px;
    height: 18px;
  }

  .v-calendar.v-calendar-events .v-calendar-weekly__day {
    overflow: hidden;
    margin-right: 0px;
    padding: 0 3px;
  }

  .v-calendar .v-event {
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
    font-size: 12px;
    cursor: pointer;
    line-height: 20px;
    margin-bottom: 2px !important;
    z-index: 1;
    border-radius: 2px !important;
    width: 100% !important;
    height: auto !important;
  }

  .theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside, .feriado {
    background: repeating-linear-gradient(
        40deg,
        #d0d5d900,
        #d0d5d961 0px,
        #d0d5d900 1px,
        #d0d5d900 4px
      ),
      linear-gradient(to bottom, #eeeeee24, #9990);
  }
  .v-toolbar__title {
    color: #430f4a;
    font-family: "Cairo";
    font-size: 16px;
    letter-spacing: 0.51px;
  }

  .title-info-menu {
    color: white;
    font-size: 11px;
  }

  .items-card {
    color: #ffffff;
    font-size: 9px;
    line-height: 11px;
    font-family: "system-ui";
    padding-bottom: 0;
    white-space: wrap !important;
  }

  .items-card.negrito {
    color: #ffffff;
    font-size: 9px;
    line-height: 11px;
    font-weight: 700;
  }

  .v-calendar .v-event-more {
    font-size: 11px !important;
    height: 15px !important;
    margin-top: 10px !important;
    color: $color-primary !important;
    background-color: transparent;
  }

  .v-toolbar__title.items-menu {
    color: white;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 10px;
    font-family: "system-ui";
  }
  .v-toolbar__title.items-menu.negrito.text-right {
    font-weight: 700 !important;
  }
  }
  // .v-dialog. {
  //   max-height: 90%;
  //   width: 30%;
  //   margin-left: 100px;
  // }
  .agenda-calendar {
    p.items-menu {
    color: white;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 10px;
    font-family: "system-ui";
  }
  p.items-menu.negrito.text-right {
    font-weight: 700 !important;
  }
    
  p.legend-day {
    font-size: 14px;
    font-weight: 600;
  }
  p.close-x {
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: $color-primary;
  }

  .internal-space-menu {
    width: 100%;
    padding: 4px 0;
    margin: 0;
  }

  .feriado {
    background: repeating-linear-gradient(
        40deg,
        #d0d5d900,
        #d0d5d961 0px,
        #d0d5d900 1px,
        #d0d5d900 4px
      ),
      linear-gradient(to bottom, #eeeeee24, #9990);
  }
}
.card-even, .card-odd
{
 border-radius: 6px;
 background-color: #06679A;
 color:#f0f0ff;
 cursor: pointer;
}
.card-odd {
 background-color: #118ACA;
}
@media (max-width: 756px) {
  #calendar {
    .calendar-body {
      height: 65%;
      margin-top: 40px;
    }

    .v-calendar .v-event-more {
      font-size: 8px;
    }

    .select-month {
      height: 40px !important;
      padding-left: 0px !important;
    }

    .btn-today {
      display: none;
    }
    .v-dialog.AgendaCalendar {
      max-height: 90%;
      width: 80%;
      margin-left: 30px;
    }
  }
}
</style>
